import ComponentList from 'components/Content/ComponentList/ComponentList';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { showAtbCarouselsHomepageSelector } from 'viewModel/selectors/testTarget/showAtbCarouselsHomepageSelector';
import { showUpdateProductNameDisplayHPSelector } from 'viewModel/selectors/testTarget/showUpdateProductNameDisplayHPSelector';
import biIdSelector from 'selectors/user/beautyInsiderAccount/biIdSelector';

const fields = createStructuredSelector({
    userId: biIdSelector,
    isCarouselsATBEnabled: showAtbCarouselsHomepageSelector,
    showUpdateProductNameDisplayHP: showUpdateProductNameDisplayHPSelector
});

export default connect(fields)(ComponentList);
